/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CateringCateringWrite,
  CateringGetCollectionFrontend200,
  CateringGetCollectionFrontendParams,
  CateringJsonldCateringRead,
  CateringJsonldCateringWrite,
  CateringJsonldCateringsRead,
  GetCateringBySlug200,
  GetCateringBySlugParams,
  GetCateringsByTier200Item,
  GetCateringsByTierParams
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type catering_postResponse201 = {
  data: CateringJsonldCateringRead
  status: 201
}

export type catering_postResponse400 = {
  data: void
  status: 400
}

export type catering_postResponse422 = {
  data: void
  status: 422
}

export type catering_postResponseSuccess = (catering_postResponse201) & {
  headers: Headers;
};
export type catering_postResponseError = (catering_postResponse400 | catering_postResponse422) & {
  headers: Headers;
};

export type catering_postResponse = (catering_postResponseSuccess | catering_postResponseError)

export const getCateringPostUrl = () => {




  return `/api/catering`
}

/**
 * Creates a Catering resource.
 * @summary Creates a Catering resource.
 */
export const catering_post = async (cateringPostBody: CateringJsonldCateringWrite | CateringCateringWrite, options?: RequestInit): Promise<catering_postResponse> => {

  return apiCatalog<catering_postResponse>(getCateringPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(cateringPostBody)
  }
);}





export const getCateringPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catering_post>>, TError,{data: CateringJsonldCateringWrite | CateringCateringWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof catering_post>>, TError,{data: CateringJsonldCateringWrite | CateringCateringWrite}, TContext> => {

const mutationKey = ['cateringPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catering_post>>, {data: CateringJsonldCateringWrite | CateringCateringWrite}> = (props) => {
          const {data} = props ?? {};

          return  catering_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CateringPostMutationResult = NonNullable<Awaited<ReturnType<typeof catering_post>>>
    export type CateringPostMutationBody = CateringJsonldCateringWrite | CateringCateringWrite
    export type CateringPostMutationError = void

    /**
 * @summary Creates a Catering resource.
 */
export const useCateringPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catering_post>>, TError,{data: CateringJsonldCateringWrite | CateringCateringWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catering_post>>,
        TError,
        {data: CateringJsonldCateringWrite | CateringCateringWrite},
        TContext
      > => {
      return useMutation(getCateringPostMutationOptions(options), queryClient);
    }
    export type catering_patchResponse200 = {
  data: CateringJsonldCateringRead
  status: 200
}

export type catering_patchResponse400 = {
  data: void
  status: 400
}

export type catering_patchResponse404 = {
  data: void
  status: 404
}

export type catering_patchResponse422 = {
  data: void
  status: 422
}

export type catering_patchResponseSuccess = (catering_patchResponse200) & {
  headers: Headers;
};
export type catering_patchResponseError = (catering_patchResponse400 | catering_patchResponse404 | catering_patchResponse422) & {
  headers: Headers;
};

export type catering_patchResponse = (catering_patchResponseSuccess | catering_patchResponseError)

export const getCateringPatchUrl = (id: string,) => {




  return `/api/catering/${id}`
}

/**
 * Updates the Catering resource.
 * @summary Updates the Catering resource.
 */
export const catering_patch = async (id: string,
    cateringCateringWrite: CateringCateringWrite, options?: RequestInit): Promise<catering_patchResponse> => {

  return apiCatalog<catering_patchResponse>(getCateringPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(cateringCateringWrite)
  }
);}





export const getCateringPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catering_patch>>, TError,{id: string;data: CateringCateringWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof catering_patch>>, TError,{id: string;data: CateringCateringWrite}, TContext> => {

const mutationKey = ['cateringPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catering_patch>>, {id: string;data: CateringCateringWrite}> = (props) => {
          const {id,data} = props ?? {};

          return  catering_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CateringPatchMutationResult = NonNullable<Awaited<ReturnType<typeof catering_patch>>>
    export type CateringPatchMutationBody = CateringCateringWrite
    export type CateringPatchMutationError = void

    /**
 * @summary Updates the Catering resource.
 */
export const useCateringPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catering_patch>>, TError,{id: string;data: CateringCateringWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catering_patch>>,
        TError,
        {id: string;data: CateringCateringWrite},
        TContext
      > => {
      return useMutation(getCateringPatchMutationOptions(options), queryClient);
    }
    export type catering_get_collection_frontendResponse200 = {
  data: CateringGetCollectionFrontend200
  status: 200
}

export type catering_get_collection_frontendResponseSuccess = (catering_get_collection_frontendResponse200) & {
  headers: Headers;
};
;

export type catering_get_collection_frontendResponse = (catering_get_collection_frontendResponseSuccess)

export const getCateringGetCollectionFrontendUrl = (params?: CateringGetCollectionFrontendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/caterings?${stringifiedParams}` : `/api/caterings`
}

/**
 * Retrieves the collection of Catering resources.
 * @summary Retrieves the collection of Catering resources.
 */
export const catering_get_collection_frontend = async (params?: CateringGetCollectionFrontendParams, options?: RequestInit): Promise<catering_get_collection_frontendResponse> => {

  return apiCatalog<catering_get_collection_frontendResponse>(getCateringGetCollectionFrontendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCateringGetCollectionFrontendQueryKey = (params?: CateringGetCollectionFrontendParams,) => {
    return [
    `/api/caterings`, ...(params ? [params] : [])
    ] as const;
    }


export const getCateringGetCollectionFrontendQueryOptions = <TData = Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError = unknown>(params?: CateringGetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCateringGetCollectionFrontendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catering_get_collection_frontend>>> = ({ signal }) => catering_get_collection_frontend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CateringGetCollectionFrontendQueryResult = NonNullable<Awaited<ReturnType<typeof catering_get_collection_frontend>>>
export type CateringGetCollectionFrontendQueryError = unknown


export function useCateringGetCollectionFrontend<TData = Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError = unknown>(
 params: undefined |  CateringGetCollectionFrontendParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catering_get_collection_frontend>>,
          TError,
          Awaited<ReturnType<typeof catering_get_collection_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCateringGetCollectionFrontend<TData = Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError = unknown>(
 params?: CateringGetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catering_get_collection_frontend>>,
          TError,
          Awaited<ReturnType<typeof catering_get_collection_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCateringGetCollectionFrontend<TData = Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError = unknown>(
 params?: CateringGetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Catering resources.
 */

export function useCateringGetCollectionFrontend<TData = Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError = unknown>(
 params?: CateringGetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCateringGetCollectionFrontendQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type get_catering_by_slugResponse200 = {
  data: GetCateringBySlug200
  status: 200
}

export type get_catering_by_slugResponseSuccess = (get_catering_by_slugResponse200) & {
  headers: Headers;
};
;

export type get_catering_by_slugResponse = (get_catering_by_slugResponseSuccess)

export const getGetCateringBySlugUrl = (slug: string,
    params?: GetCateringBySlugParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/caterings-slug/${slug}?${stringifiedParams}` : `/api/caterings-slug/${slug}`
}

/**
 * Retrieves the collection of Catering resources.
 * @summary Retrieves the collection of Catering resources.
 */
export const get_catering_by_slug = async (slug: string,
    params?: GetCateringBySlugParams, options?: RequestInit): Promise<get_catering_by_slugResponse> => {

  return apiCatalog<get_catering_by_slugResponse>(getGetCateringBySlugUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCateringBySlugQueryKey = (slug: string,
    params?: GetCateringBySlugParams,) => {
    return [
    `/api/caterings-slug/${slug}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCateringBySlugQueryOptions = <TData = Awaited<ReturnType<typeof get_catering_by_slug>>, TError = unknown>(slug: string,
    params?: GetCateringBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCateringBySlugQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_catering_by_slug>>> = ({ signal }) => get_catering_by_slug(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCateringBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof get_catering_by_slug>>>
export type GetCateringBySlugQueryError = unknown


export function useGetCateringBySlug<TData = Awaited<ReturnType<typeof get_catering_by_slug>>, TError = unknown>(
 slug: string,
    params: undefined |  GetCateringBySlugParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_catering_by_slug>>,
          TError,
          Awaited<ReturnType<typeof get_catering_by_slug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCateringBySlug<TData = Awaited<ReturnType<typeof get_catering_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetCateringBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_catering_by_slug>>,
          TError,
          Awaited<ReturnType<typeof get_catering_by_slug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCateringBySlug<TData = Awaited<ReturnType<typeof get_catering_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetCateringBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Catering resources.
 */

export function useGetCateringBySlug<TData = Awaited<ReturnType<typeof get_catering_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetCateringBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_catering_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCateringBySlugQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type get_caterings_by_tierResponse200 = {
  data: GetCateringsByTier200Item[]
  status: 200
}

export type get_caterings_by_tierResponseSuccess = (get_caterings_by_tierResponse200) & {
  headers: Headers;
};
;

export type get_caterings_by_tierResponse = (get_caterings_by_tierResponseSuccess)

export const getGetCateringsByTierUrl = (tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/caterings-tier/${tier}?${stringifiedParams}` : `/api/caterings-tier/${tier}`
}

/**
 * Returns an array of caterings that belong to the provided tier and are marked as active.
 * @summary List active caterings for the given tier.
 */
export const get_caterings_by_tier = async (tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams, options?: RequestInit): Promise<get_caterings_by_tierResponse> => {

  return apiCatalog<get_caterings_by_tierResponse>(getGetCateringsByTierUrl(tier,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCateringsByTierQueryKey = (tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams,) => {
    return [
    `/api/caterings-tier/${tier}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCateringsByTierQueryOptions = <TData = Awaited<ReturnType<typeof get_caterings_by_tier>>, TError = unknown>(tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCateringsByTierQueryKey(tier,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_caterings_by_tier>>> = ({ signal }) => get_caterings_by_tier(tier,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tier !== null && tier !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCateringsByTierQueryResult = NonNullable<Awaited<ReturnType<typeof get_caterings_by_tier>>>
export type GetCateringsByTierQueryError = unknown


export function useGetCateringsByTier<TData = Awaited<ReturnType<typeof get_caterings_by_tier>>, TError = unknown>(
 tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params: undefined |  GetCateringsByTierParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_caterings_by_tier>>,
          TError,
          Awaited<ReturnType<typeof get_caterings_by_tier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCateringsByTier<TData = Awaited<ReturnType<typeof get_caterings_by_tier>>, TError = unknown>(
 tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_caterings_by_tier>>,
          TError,
          Awaited<ReturnType<typeof get_caterings_by_tier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCateringsByTier<TData = Awaited<ReturnType<typeof get_caterings_by_tier>>, TError = unknown>(
 tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active caterings for the given tier.
 */

export function useGetCateringsByTier<TData = Awaited<ReturnType<typeof get_caterings_by_tier>>, TError = unknown>(
 tier: 'BASIC' | 'STANDARD' | 'PREMIUM',
    params?: GetCateringsByTierParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_caterings_by_tier>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCateringsByTierQueryOptions(tier,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type catering_get_frontendResponse200 = {
  data: CateringJsonldCateringsRead
  status: 200
}

export type catering_get_frontendResponse404 = {
  data: void
  status: 404
}

export type catering_get_frontendResponseSuccess = (catering_get_frontendResponse200) & {
  headers: Headers;
};
export type catering_get_frontendResponseError = (catering_get_frontendResponse404) & {
  headers: Headers;
};

export type catering_get_frontendResponse = (catering_get_frontendResponseSuccess | catering_get_frontendResponseError)

export const getCateringGetFrontendUrl = (id: string,) => {




  return `/api/caterings/${id}`
}

/**
 * Retrieves a Catering resource.
 * @summary Retrieves a Catering resource.
 */
export const catering_get_frontend = async (id: string, options?: RequestInit): Promise<catering_get_frontendResponse> => {

  return apiCatalog<catering_get_frontendResponse>(getCateringGetFrontendUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCateringGetFrontendQueryKey = (id: string,) => {
    return [
    `/api/caterings/${id}`
    ] as const;
    }


export const getCateringGetFrontendQueryOptions = <TData = Awaited<ReturnType<typeof catering_get_frontend>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCateringGetFrontendQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catering_get_frontend>>> = ({ signal }) => catering_get_frontend(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CateringGetFrontendQueryResult = NonNullable<Awaited<ReturnType<typeof catering_get_frontend>>>
export type CateringGetFrontendQueryError = void


export function useCateringGetFrontend<TData = Awaited<ReturnType<typeof catering_get_frontend>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catering_get_frontend>>,
          TError,
          Awaited<ReturnType<typeof catering_get_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCateringGetFrontend<TData = Awaited<ReturnType<typeof catering_get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catering_get_frontend>>,
          TError,
          Awaited<ReturnType<typeof catering_get_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCateringGetFrontend<TData = Awaited<ReturnType<typeof catering_get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Catering resource.
 */

export function useCateringGetFrontend<TData = Awaited<ReturnType<typeof catering_get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catering_get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCateringGetFrontendQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






